function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M5.795 1.351c-2.355 0-4.266 1.823-4.266 4.067v23.579c0 2.244 1.91 4.064 4.266 4.064h1.429l.042 8.457 10.208-8.457h21.002c2.356 0 4.267-1.82 4.267-4.064V5.418c0-2.244-1.911-4.067-4.267-4.067H5.796z"
}), /*#__PURE__*/React.createElement("path", {
  id: "c",
  d: "M4.34.093C2.09.093.267 1.785.267 3.873v21.935c0 2.088 1.822 3.78 4.073 3.78h1.362l.038 7.868 9.743-7.867h20.051c2.248 0 4.074-1.693 4.074-3.781V3.874c0-2.089-1.826-3.781-4.074-3.781H4.34z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F8F9FF",
  d: "M153.334 82.839h-26.668c-3.666 0-6.666 3.007-6.666 6.68 0 3.678 3 6.684 6.666 6.684h26.668c3.666 0 6.666 3.007 6.666 6.681s-3 6.681-6.666 6.681H20c-3.666 0-6.666-3.007-6.666-6.68 0-3.675 3-6.682 6.666-6.682h26.666c3.665 0 6.668-3.006 6.668-6.683 0-3.674-3.003-6.681-6.668-6.681H10c-3.666 0-6.666-3.007-6.666-6.681s3-6.684 6.666-6.684h28.334c2.749 0 5-2.254 5-5.011 0-2.755-2.251-5.012-5-5.012H6.666C3 59.451 0 56.445 0 52.771s3-6.681 6.666-6.681h140c3.665 0 6.668 3.007 6.668 6.68 0 3.675-3.003 6.681-6.668 6.681H115c-2.751 0-5 2.257-5 5.012 0 2.757 2.249 5.011 5 5.011h38.334c3.666 0 6.666 3.01 6.666 6.684 0 3.674-3 6.68-6.666 6.68"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E3E9FD",
  d: "M16.306 23.295c0 .79-.64 1.432-1.429 1.432a1.43 1.43 0 0 1-1.428-1.432c0-.79.64-1.431 1.428-1.431a1.43 1.43 0 0 1 1.429 1.431M143.571 109.565c0 .79-.64 1.432-1.428 1.432a1.43 1.43 0 0 1 0-2.863c.788 0 1.428.644 1.428 1.431"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#E3E9FD",
  strokeWidth: 2.143,
  d: "M17.734 125.036a4.292 4.292 0 0 1-4.285 4.295 4.292 4.292 0 0 1-4.286-4.295 4.292 4.292 0 0 1 4.286-4.296 4.292 4.292 0 0 1 4.285 4.296z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#E3E9FD",
  strokeLinecap: "round",
  strokeWidth: 2.143,
  d: "M136.429 41.808H145M140.714 46.104v-8.591"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E3E9FD",
  d: "M126.32 26.282a2.858 2.858 0 1 1-5.715 0 2.858 2.858 0 0 1 5.714 0"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#E3E9FD",
  strokeLinejoin: "round",
  strokeWidth: 1.429,
  d: "M125.483 131.94v1.432-2.864zM125.483 140.531v1.432-2.864zM121.197 136.236h1.428-2.857zM129.768 136.236h1.429-2.857zM128.513 133.199l-1.012 1.013 1.012-1.013 1.011-1.014zM122.453 139.273l-1.012 1.013 1.012-1.013 1.011-1.014zM122.453 133.199l1.011 1.013-1.011-1.013-1.012-1.014zM128.513 139.273l1.011 1.013-1.011-1.013-1.012-1.014zM35.737 20.432v1.432V19zM35.737 29.023v1.432-2.864zM31.45 24.727h1.43H30.021zM40.022 24.727h1.429-2.857zM38.767 21.69l-1.012 1.014 1.012-1.014 1.011-1.014zM32.707 27.764l-1.012 1.014 1.012-1.014 1.011-1.014zM32.707 21.69l1.011 1.014-1.011-1.014-1.012-1.014zM38.767 27.764l1.011 1.014-1.011-1.014-1.012-1.014z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M125.58 37.11H28.706c-.863 0-1.563.702-1.563 1.567v78.303c0 .862.7 1.563 1.563 1.563h96.874c.863 0 1.563-.701 1.563-1.563V38.677c0-.865-.7-1.567-1.563-1.567"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#DAE1FD",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.143,
  d: "M125.58 37.11H28.706c-.863 0-1.563.702-1.563 1.567v78.303c0 .862.7 1.563 1.563 1.563h96.874c.863 0 1.563-.701 1.563-1.563V38.677c0-.865-.7-1.567-1.563-1.567z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EDF0FE",
  d: "M125.58 37.11H28.706c-.863 0-1.563.702-1.563 1.567V55.9h100V38.677c0-.865-.7-1.567-1.563-1.567"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#DAE1FD",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.143,
  d: "M125.58 37.11H28.706c-.863 0-1.563.702-1.563 1.567V55.9h100V38.677c0-.865-.7-1.567-1.563-1.567z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EDF0FE",
  d: "M31.83 116.979V38.675c0-.864.7-1.566 1.563-1.566h-4.688c-.863 0-1.563.702-1.563 1.566v78.304c0 .865.7 1.566 1.563 1.566h4.688a1.565 1.565 0 0 1-1.563-1.566"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DAE1FD",
  d: "M117.768 41.808c-2.583 0-4.689 2.108-4.689 4.7a4.7 4.7 0 0 0 4.689 4.696 4.7 4.7 0 0 0 4.689-4.696c0-2.592-2.106-4.7-4.689-4.7"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M117.768 43.374a3.13 3.13 0 0 0-3.126 3.133c0 1.727 1.4 3.133 3.126 3.133a3.132 3.132 0 0 0 3.126-3.133 3.13 3.13 0 0 0-3.126-3.133"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#DAE1FD",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.143,
  d: "M117.768 43.374a3.13 3.13 0 0 0-3.126 3.133c0 1.727 1.4 3.133 3.126 3.133a3.132 3.132 0 0 0 3.126-3.133 3.13 3.13 0 0 0-3.126-3.133z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DAE1FD",
  d: "M105.268 41.808c-2.583 0-4.689 2.108-4.689 4.7a4.7 4.7 0 0 0 4.689 4.696 4.7 4.7 0 0 0 4.689-4.696c0-2.592-2.106-4.7-4.689-4.7"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M105.268 43.374a3.13 3.13 0 0 0-3.126 3.133c0 1.727 1.4 3.133 3.126 3.133a3.132 3.132 0 0 0 3.126-3.133 3.13 3.13 0 0 0-3.126-3.133"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#DAE1FD",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.143,
  d: "M105.268 43.374a3.13 3.13 0 0 0-3.126 3.133c0 1.727 1.4 3.133 3.126 3.133a3.132 3.132 0 0 0 3.126-3.133 3.13 3.13 0 0 0-3.126-3.133z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DAE1FD",
  d: "M92.768 41.808c-2.583 0-4.689 2.108-4.689 4.7a4.7 4.7 0 0 0 4.689 4.696 4.7 4.7 0 0 0 4.689-4.696c0-2.592-2.106-4.7-4.689-4.7"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M92.768 43.374a3.13 3.13 0 0 0-3.126 3.133c0 1.727 1.4 3.133 3.126 3.133a3.132 3.132 0 0 0 3.126-3.133 3.13 3.13 0 0 0-3.126-3.133"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#DAE1FD",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.143,
  d: "M92.768 43.374a3.13 3.13 0 0 0-3.126 3.133c0 1.727 1.4 3.133 3.126 3.133a3.132 3.132 0 0 0 3.126-3.133 3.13 3.13 0 0 0-3.126-3.133z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DAE1FD",
  d: "M36.518 48.072h-1.563a1.565 1.565 0 0 1-1.563-1.566c0-.865.7-1.566 1.563-1.566h1.563c.863 0 1.563.701 1.563 1.566 0 .865-.7 1.566-1.563 1.566M44.33 48.072h-3.125a1.565 1.565 0 0 1-1.563-1.566c0-.865.7-1.566 1.563-1.566h3.125c.863 0 1.563.701 1.563 1.566 0 .865-.7 1.566-1.563 1.566M50.58 48.072h-1.563a1.565 1.565 0 0 1-1.562-1.566c0-.865.7-1.566 1.562-1.566h1.563c.863 0 1.563.701 1.563 1.566 0 .865-.7 1.566-1.563 1.566"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#DAE1FD",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.143,
  d: "M125.58 37.11H28.706c-.863 0-1.563.702-1.563 1.567v78.303c0 .862.7 1.563 1.563 1.563h96.874c.863 0 1.563-.701 1.563-1.563V38.677c0-.865-.7-1.567-1.563-1.567z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#DAE1FD",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.143,
  d: "M125.58 37.11H28.706c-.863 0-1.563.702-1.563 1.567V55.9h100V38.677c0-.865-.7-1.567-1.563-1.567z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(96 67.284)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#E3E9FD",
  d: "M-3.155 46.187h50.58V-3.317h-50.58z",
  mask: "url(#b)"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#DAE1FD",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.886,
  d: "M134.475 68.636h-32.68c-2.356 0-4.265 1.823-4.265 4.067v23.576c0 2.246 1.909 4.064 4.265 4.064h1.428l.043 8.46 10.205-8.46h21.004c2.356 0 4.267-1.818 4.267-4.064V72.703c0-2.244-1.91-4.067-4.267-4.067"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(98.2 69.478)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M-4.418 42.125H44.29V-4.578H-4.418z",
  mask: "url(#d)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#DAE1FD",
  d: "M118.786 90.007c1.215 0 2.2.981 2.2 2.194a2.196 2.196 0 0 1-2.2 2.193c-1.216 0-2.2-.981-2.2-2.193 0-1.213.984-2.194 2.2-2.194"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#DAE1FD",
  strokeLinecap: "round",
  strokeWidth: 3.3,
  d: "M118.786 86.716v-10.97"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#DAE1FD",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M37 70.284h20M37 78.284h32M37 94.784h52M37 102.784h52"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h160v160H0z"
}));

var SvgErrorDesktop = function SvgErrorDesktop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgErrorDesktop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error-desktop.fed05ed5.svg";
export { ForwardRef as ReactComponent };